// Links de vídeo com capa automática — os mesmos que o servidor busca
// (EmailBuilder::VideoThumbnail::YOUTUBE / VIMEO).
const YOUTUBE =
  /(?:youtube\.com\/(?:watch\?(?:\S*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)[\w-]{11}/i;
const VIMEO = /vimeo\.com\/(?:video\/)?\d+/i;

export const videoProvider = url => {
  const value = String(url || '');
  if (YOUTUBE.test(value)) return 'youtube';
  if (VIMEO.test(value)) return 'vimeo';
  return null;
};
